import { FC } from "react";

interface props {
  checked?: boolean;
  title: string;
  onClick: () => void;
}

export const Radio: FC<props> = (props) => {
  return (
    <div className="form-control">
      <label className="label cursor-pointer justify-start gap-2">
        <input
          type="radio"
          className="radio radio-primary radio-xs"
          checked={props.checked}
          onClick={props.onClick}
        />
        <span className="label-text">{props.title}</span>
      </label>
    </div>
  );
};
